<dynamic-material-form
  #form
  [model]="formModel"
  [group]="formGroup"
  (change)="onFormChange($event)"
  (matEvent)="onCustomEvent($event, null, true)"
  data-test="gsm-schadenbeteiligter-kontakt-erfassen_form"
>
</dynamic-material-form>
